import type {AppThunk} from '../../../actions/types'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../routes/loadEndpoint'
import {restApi} from '../../../services/rest'
import type {BuildId} from '../../../types'

import {getBuildArtifactDependenciesChangesArg} from './ArtifactChanges.rest'

export const preloadArtifactChanges =
  (buildId: BuildId): AppThunk<LoadedEndpoints> =>
  dispatch => [
    dispatch(
      loadEndpoint(
        restApi.endpoints.getBuildNormalized,
        getBuildArtifactDependenciesChangesArg(buildId),
      ),
    ),
  ]
